module.exports = fox._r("images/promo/lang-arr-d-w.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/lang-arr-d-w.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/lang-arr-d-w.png
// module id = 13
// module chunks = 2